export default "__VITE_ASSET__03dea729__"